/**
 * Created by rak on 1/15/2016.
 */
'use strict';
angular.module('trackReporting').service('reportService', function (crudService, $q, Restangular, AuthenticationService, localStorageService, $window, $translate, toastService, widgetSettingsCreatorService, commonTrackService) {

  var ReportProps = function () {
    return {
      reportList: [],
      reportOptionList: [],
      exportPath: ''
    };
  };
  var reportSettingsObj = {
    performancereport: new ReportProps(),
    groupdetailsreport: new ReportProps(),
    vehicledetailsreport: new ReportProps(),
    groupsummary: new ReportProps()
  };

  this.getVehilceReport = function (modelName, deviceid, timeTo, timeFrom, dataRefresh, reportName, reportOption, reportOptions) {
    var param = generateReqParms(deviceid, timeTo, timeFrom, dataRefresh, reportName, reportOption, 'device', reportOptions);
    return crudService.customGET(modelName, reportName.toLowerCase(), param);
  };


  this.getGroupReport = function (modelName, groupId, timeTo, timeFrom, dataRefresh, reportName, reportOption) {
    var param = generateReqParms(groupId, timeTo, timeFrom, dataRefresh, reportName, reportOption, 'group');
    return crudService.customGET(modelName, reportName.split('_Group')[0].toLowerCase(), param);
  };

  function generateReqParms(typeId, timeTo, timeFrom, dataRefresh, reportName, reportOption, type, reportOptions) {
    var requestParam = {};
    if (type === 'group') {
      requestParam.vehicleGroup = typeId;
    }
    if (type === 'device') {
      requestParam.deviceid = typeId;
    }
    requestParam.dataRefresh = dataRefresh;
    requestParam.timeTo = timeTo;
    requestParam.timeFrom = timeFrom;
    requestParam.reportName = reportName;
    requestParam.reportOption = reportOption;
    requestParam.reportOptions = reportOptions;
    var param = {
      'filter': JSON.stringify(requestParam)
    };
    return param;
  }

  this.getTripReportOptions = function () {
    return crudService.get('vehicledetailsreport/options/tripreport');
  };

  this.getMotionSummaryOptions = function () {
    return crudService.get('vehicledetailsreport/options/motionsummary');
  };

  this.getDigitalInputDetailReportOptions = function () {
    return crudService.get('vehicledetailsreport/options/digitalinputdetailreport');
  };

  this.getEventCountByDayOptions = function () {
    return crudService.get('vehicledetailsreport/options/eventcountbyday');
  };

  this.getDeviceNearbyDevicesOptions = function () {
    return crudService.get('vehicledetailsreport/options/devicenearbydevices');
  };

  this.getCustomVehicleRepotOptionComboData = function (reportOptionComboType) {
    return crudService.get('vehicledetailsreport/options/' + reportOptionComboType.toLowerCase());
  };

  this.getCustomGroupRepotOptionComboData = function (reportOptionComboType) {
    return crudService.get('groupdetailsreport/options/' + reportOptionComboType.toLowerCase());
  };

  this.getCustomPerformanceRepotOptionComboData = function (reportOptionComboType) {
    return crudService.get('performancereport/options/' + reportOptionComboType.toLowerCase());
  };

  this.getCustomGroupSummaryRepotOptions = function (reportOptionComboType) {
    return crudService.get('groupsummary/options/' + reportOptionComboType.toLowerCase());
  };

  this.getExportSettings = function () {
    var source = [
      'HTML', 'CSV', 'XLS', 'EMail'
    ];

    // init DropDownList's settings object.
    var exportSettings =
    {
      placeHolder: 'format : ',
      width: 200, height: 25,
      autoDropDownHeight: true,

      theme: widgetSettingsCreatorService.fetchWidgetStyleSettings().theme, // 'material', // theme: 'bootstrap',
      source: source
    };

    return exportSettings;
  };

  this.vehicleDetailReportProperties = function () {
    var repotProperty = {
      'EventDetailAll': {
        hasMap: true
      }
    };
    return repotProperty;
  };

  String.prototype._toLowerCaseAtIndex = function (index) {
    return this.charAt(index).toLocaleLowerCase() + this.slice(1);
  };

  this.driverWrkHrsDatevVtmDownload = function (modelName, deviceid, timeTo, timeFrom, dataRefresh, reportName, reportOption, reportOptions) {
    var param = generateReqParms(deviceid, timeTo, timeFrom, dataRefresh, reportName, reportOption, 'device', reportOptions);
    return Restangular.one(modelName + '/' + reportName.toLowerCase() + '/download/vtm'  +'?filter='+encodeURI(param.filter)).withHttpConfig({ responseType: 'arraybuffer' }).get();
  };
  this.driverWrkHrsDatevExcelDownload = function (modelName, deviceid, timeTo, timeFrom, dataRefresh, reportName, reportOption, reportOptions) {
    var param = generateReqParms(deviceid, timeTo, timeFrom, dataRefresh, reportName, reportOption, 'device', reportOptions);
    return Restangular.one(modelName + '/' + reportName.toLowerCase() + '/download/xls' + '?filter='+encodeURI(param.filter)).withHttpConfig({ responseType: 'arraybuffer' }).get();
  };

  this.getReportSettings = function (moduleName) {
    if (reportSettingsObj[moduleName].reportList.length > 0) {
      var deferred = $q.defer();
      deferred.resolve(reportSettingsObj[moduleName]);
      return deferred.promise;
    }
    else {
      return crudService.get(moduleName + '/reportsettings/').then(function (repoSetting) {

        for (var i = 0; i < repoSetting.reportSettings.length; i++) {
          var _tmpRepName = repoSetting.reportSettings[i].reportName.toLoawerCaseAt(0);
          reportSettingsObj[moduleName].reportList.push({
            _isEnabled: repoSetting.reportSettings[i].enabled,
            _reportName: repoSetting.reportSettings[i].reportName,
            _idName: _tmpRepName + 'Radio',
            _translationProp: 'trackReporting.performanceReport.' + _tmpRepName,
            _hasOption: repoSetting.reportSettings[i].reportOptionName ? true : false,
            _isReportOptionMultiSelect: repoSetting.reportSettings[i].reporOptionMultiSelect || false,
            _multiSelectPropertyName: repoSetting.reportSettings[i].multiSelectPropertyName || '',
            _comboID: repoSetting.reportSettings[i].reportOptionName + 'ComboBox' || '',
            _comboModelName: repoSetting.reportSettings[i].reportOptionName || '',
            _comboSettings: _tmpRepName + 'Settings',
            _hasMap: repoSetting.reportSettings[i].hasMap,
            _hasExportBtn: repoSetting.reportSettings[i].hasCustomExportBtn || false
          });
        }
        reportSettingsObj[moduleName].reportOptionList = repoSetting.reportOptionsList;
        reportSettingsObj[moduleName].exportPath = repoSetting.exportPath;
        return reportSettingsObj[moduleName];
      });
    }
  };

  this.getReportSpliterWithMapPanel = function () {
    return {
      width: '100%',
      height: 725,
      orientation: 'vertical',
      splitBarSize: 10,
      panels: [{ size: '80%', collapsible: true }, { size: '20%', collapsible: false }]
    };
  };
  this.getReportSplitterWithoutMapPannel = function () {
    return {
      width: '100%',
      height: 725,
      orientation: 'vertical',
      splitBarSize: 0,
      panels: [{ size: '100%', collapsible: false }]
    };
  };
  /**
   * Following method used to store GridState to manually to the local storage
   * @param reportType
   * @param reportName
   * @param gridState
   */
  this.setReportGridState = function (reportType, reportName, gridState) {
    var loginID = AuthenticationService.GetLoginID();
    localStorageService.set(reportType + '.' + reportName + '.' + loginID.Account + '.' + loginID.username, gridState);
  };
  /**
   * Following method used o retrieve the GridState of the specified Report
   * @param reportType
   * @param reportName
   */
  this.getReportGridState = function (reportType, reportName) {
    var loginID = AuthenticationService.GetLoginID();
    return localStorageService.get(reportType + '.' + reportName + '.' + loginID.Account + '.' + loginID.username);
  };

  this.doExport = function (exportURL, reportName, type) {


    Restangular.one('reportexport' + '/initexport/'+reportName+'/'+type+'?filter=' + exportURL)
      .withHttpConfig({ responseType: 'arraybuffer' })

      .get().then(function (data) {

        var blob;
        switch (type) {
          case 'XLS':
            blob = new $window.Blob([data], {
              type: 'application/vnd.ms-excel ;charset=windows-1252'
            });
            break;
          case 'EMail':
            toastService.showSuccessToast($translate.instant('trackReporting.emailSendSuccessfully'));
            return data;
          default:
            blob = new $window.Blob([new Uint8Array([0xEF, 0xBB, 0xBF]), data], { type: 'text/' + type.toLocaleLowerCase() });
        }

        var repoExportName = 'Track_' + reportName + '.' + type.toLocaleLowerCase();
        saveAs(blob, repoExportName);
        toastService.showSuccessToast($translate.instant('trackReporting.reportExportSuccess'));



      }, function (/* response */) {
        if (type === 'EMail') {
          toastService.showWarningToast($translate.instant('trackReporting.emailSendingFailed'));
        } else {
          toastService.showWarningToast($translate.instant('trackReporting.reportExportFailed'));
        }

      });
  };



  this.loadReportCustomGridState = function (translationObj, gridId, gridSetting, localStorageCustomVal, gridLocalStorageUserSettingKey) {
   var userSettings =  commonTrackService.getGtsLocalStorageSettings();
    if (translationObj !== null && translationObj.columnTranslation) {
      if (localStorageCustomVal && localStorageCustomVal.columns) {
        for (var gridColumn in localStorageCustomVal.columns) {
          if (translationObj.columnTranslation[gridColumn] !== undefined) {
            localStorageCustomVal.columns[gridColumn].text = translationObj.columnTranslation[gridColumn];//rewrite
          }
          if (gridSetting && gridSetting.columns) {
            for (var f = 0; f < gridSetting.columns.length; f++) {
              if (localStorageCustomVal.columns[gridColumn].text === gridSetting.columns[f].text) {
                localStorageCustomVal.columns[gridColumn].hidden = gridSetting.columns[f].hidden;
                localStorageCustomVal.columns[gridColumn].pinned= false;// reset pinned column
                break;
              }
            }
          }
        }
      }
    }
    if (userSettings && userSettings.gridsSetting[gridLocalStorageUserSettingKey] ) {
      //set column order
      if(userSettings.gridsSetting[gridLocalStorageUserSettingKey].columnsOrders){
        for (var showIndex in userSettings.gridsSetting[gridLocalStorageUserSettingKey].columnsOrders) {

          var fieldName = userSettings.gridsSetting[gridLocalStorageUserSettingKey].columnsOrders[showIndex].name;
          if (localStorageCustomVal.columns[fieldName]) {
            localStorageCustomVal.columns[fieldName].index = parseInt(showIndex);
          }
        }
      }
      // set the frozen column from userSetting local object to grdi custom local storage entry .
      if (userSettings.gridsSetting[gridLocalStorageUserSettingKey].frozenColumns) {
        for (var pinnedIndex in userSettings.gridsSetting[gridLocalStorageUserSettingKey].frozenColumns) {
          var pinnedfieldName = userSettings.gridsSetting[gridLocalStorageUserSettingKey].columnsOrders[pinnedIndex].name;
          if (localStorageCustomVal.columns[pinnedfieldName]) {
            localStorageCustomVal.columns[pinnedfieldName].pinned = true;
          }
        }
      }
    }


    $(gridId).jqxGrid('loadstate', localStorageCustomVal);
    $(gridId).jqxGrid('selectrow', 0);
  };
});



// WEBPACK FOOTER //
// ./.tmp/components/track/reports/reportService.js